
const CANCELED = "CANCELED"
const APPROVED = "APPROVED"


export default {
  CANCELED,
  APPROVED
}